// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesLibraryPreviewService', () => import('js/DesLibraryPreviewService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "data": {
        "previewThumbnail": ""
    },
    "lifecycleHooks": {
        "onMount": "getLibraryImageDetails"
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "actions": {
        "getLibraryImageDetails": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query getLibrary( $libraryId: String) {getLibrary( libraryId: $libraryId) }",
                        "variables": {
                            "libraryId": "{{props.libraryid}}"
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "thumbnailUrlObtained": "data.data.getLibrary.libraryObjs[0].thumbnailURL"
            },
            "events": {
                "failure": [
                    {
                        "name": "getLibraryImageFailure",
                        "eventData": {
                            "eventData": "{{thumbnailUrlObtained}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "getLibraryImageSuccess",
                        "eventData": {
                            "eventData": "{{thumbnailUrlObtained}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "updatePreviewThumbnail": {
            "actionType": "JSFunction",
            "method": "updatethumbnail",
            "inputData": {
                "vmo": "{{data}}",
                "thumbnail": "{{parameters.eventData}}"
            },
            "deps": "js/DesLibraryPreviewService"
        }
    },
    "onEvent": [
        {
            "eventId": "getLibraryImageSuccess",
            "action": "updatePreviewThumbnail",
            "inputArgs": {
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "getLibraryImageFailure",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "getLibraryFailure",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "i18n": {
        "previewCaption": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesLibraryPreview",
    "_uniqueViewModelId": "DesLibraryPreview",
    "ctx": {}
};

    /*
    <aw-panel-section caption="i18n.previewCaption" collapsed="false">
    <img src={{data.previewThumbnail}} alt="Preview" width="50%" height="33%">
</aw-panel-section>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanelSection caption={i18n.previewCaption} collapsed="false">
        <img src={AwParseService.instance( "data.previewThumbnail" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} alt="Preview" width="50%" height="33%">
        </img>
    </AwPanelSection>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;